import { Inset, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type RootProps = {
  color: any
  marginTop?: string
}

type ButtonProps = {
  interactiveColor: any
}

export const Root = styled(Inset)`
  background: ${(props: RootProps) => props.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  z-index: 3;
  margin-top: ${(props: RootProps) =>
    props.marginTop ? props.marginTop : '60px'};
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 100%;
  cursor: pointer;
  height: ${Spacing.XLarge}px;
  width: ${Spacing.XLarge}px;
  outline: none;
  padding: 0;
  border: none;
  margin: -${Spacing.XxSmall}px;
  &:hover {
    background: ${(props: ButtonProps) => props.interactiveColor};
  }
`
